/**
 * @license
 * @copyright Copyright Motili Inc., 2023 All Rights Reserved
 */

import { ReactElement } from 'react';
import GetStarted from './GetStarted';

export default function GetStartedPage(): ReactElement {
    return <GetStarted />;
}
